import React, { useState } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import { HotKeys } from 'react-hotkeys';

import TextInput from '../TextInput';
import { TagButton, TagsWrapper, Wrapper } from './styles';

const hotKeysMap = {
  submit: 'enter',
  cancel: ['esc'],
};

export interface Props {
  name: string;
  placeholder?: string;
  items: string[];
  handleChange: (name: string, val: string[]) => void;
}

const TagsInput = ({
  name,
  placeholder = 'Fill in TAG here and press enter',
  items = [],
  handleChange,
}: Props) => {
  const [tagValue, setTagValue] = useState<string>('');

  const handleCancel = () => {
    setTagValue('');
  };

  const handleSubmit = () => {
    if (tagValue) {
      handleChange(name, items.includes(tagValue) ? items : [...items, tagValue]);
      handleCancel();
    }

    const element = document.querySelector('.form-wrapper');
    if (element && items.length == 0) {
      const distanceFromTop = element?.scrollTop;
      element.scroll({
        top: distanceFromTop + 50,
        behavior: 'smooth',
      });
    }
  };

  const removeTag = (tag: string) =>
    handleChange(
      name,
      items.filter((el) => el !== tag),
    );

  return (
    <Wrapper>
      <HotKeys keyMap={hotKeysMap}>
        <HotKeys
          handlers={{
            submit: handleSubmit,
            cancel: handleCancel,
          }}>
          <TextInput
            name={name}
            value={tagValue}
            handleChange={(e) => setTagValue(e.target.value)}
            placeHolder={placeholder}
          />
        </HotKeys>
      </HotKeys>
      <TagsWrapper>
        {items.map((item: string) => (
          <TagButton key={item}>
            <span>{item}</span>
            <CloseIcon onClick={() => removeTag(item)} />
          </TagButton>
        ))}
      </TagsWrapper>
    </Wrapper>
  );
};

export default TagsInput;
